import { InlineInput } from '@velasca/ui/inline-input'
import { SansText } from '@velasca/ui/sans-text'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'
import { Container } from './NotifyForm.styles'
import type { NotifyFormProps } from './NotifyForm.types'

export const NotifyForm = ({
  complete,
  completeTitle,
  title,
  loading,
  email,
  placeholder,
  policyText,
  completeText,
  onKeyDown,
  onChange,
  onSubmit,
  className,
}: NotifyFormProps) => {
  return (
    <form
      id="notifyme-form"
      className={className}
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      {!complete && (
        <Container>
          <SansText uppercase fontWeight="500" color="primary">
            {title}
          </SansText>
          <InlineInput
            bordered
            loading={loading}
            name="email"
            type="email"
            value={email}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onChange={(e) => {
              onChange(e.target.value)
            }}
          />
          <SansText
            fontWeight="500"
            dangerouslySetInnerHTML={sanitizeHTML(policyText)}
          />
        </Container>
      )}
      {complete && (
        <Container>
          <SansText uppercase fontWeight="500" color="primary">
            {completeTitle}
          </SansText>
          <SansText>{completeText}</SansText>
        </Container>
      )}
    </form>
  )
}
